exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".terms-and-conditions {\n  font-weight: bold;\n  font-size: 1.3rem; }\n\n.alert-message {\n  position: fixed;\n  left: 35%;\n  top: 0;\n  z-index: 10000;\n  width: 30%;\n  text-align: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/main/app.component.scss
// module id = 500
// module chunks = 0